module.exports = __webpack_public_path__ + "img/banner_chuseock.ff7a6341.png";